import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-customerdialog',
  templateUrl: './customerdialog.component.html',
  styleUrls: ['./customerdialog.component.scss'],
})
export class CustomerdialogComponent {
  constructor(private dialogRef: MatDialogRef<CustomerdialogComponent>) { }

  closeDialog(isTrue: Boolean) {
    this.dialogRef.close(isTrue);
  }
}
